<!--section about us-->
<section class="teamrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>SFI Team</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section id="team" class="team section-bg">
    <div class="container" data-aos="fade-up">
  
      <ngx-skeleton-loader count="5" appearance="line" *ngIf="sfiTeam===undefined"></ngx-skeleton-loader>
      <!-- <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'200px'" *ngIf="sfiTeam===undefined"></ngx-shimmer-loading> -->
  
      <div class="row" *ngIf="sfiTeam!==undefined">
  
        <div class="col-lg-3 col-xs-12 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100" style="cursor: pointer;display: flex;align-items: center;justify-content: center;" *ngFor="let user of sfiTeam">
          <div class="member" data-aos="fade-up" data-aos-delay="100">
            <div class="member-img">            
              <img [src]="'data:image/png;base64,'+user.avatar"  alt="">
            </div>
            <div class="member-info" style="cursor: pointer;">
              <h4>{{user.name}}</h4>
              <span>{{user.designation}}</span>
              <a href="mailto:{{user.email}}" style="cursor: pointer;"><i class="fa fa-envelope-o"></i><label style="margin:10px;font-size: 15px;cursor: pointer;">{{user.email}}</label></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section><!-- End Team Section -->